export default __webpack_public_path__ + "static/media/docker.8986de52.svg";